/**
 * Politique de mot de passe côté client (SEC-H7).
 *
 * ⚠️ Doit rester synchronisée avec LIMITS.PASSWORD_MIN_LENGTH dans
 * backend/src/utils/validation.js. Il n'y a pas de code partagé entre le back et
 * le front : la valeur est donc dupliquée, mais à UN SEUL endroit de chaque côté.
 *
 * Cette validation est un confort d'interface, pas une garantie : le serveur
 * refait le contrôle et fait autorité. Elle sert à éviter un aller-retour réseau
 * pour se prendre un 400.
 */
export const PASSWORD_MIN_LENGTH = 12;

/**
 * @returns un message d'erreur, ou null si le mot de passe convient.
 */
export function validatePasswordStrength(password: string): string | null {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères`;
  }
  return null;
}
